import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import image from "./top.png";
import { GetParam } from "../../pkg/query/getparam";
import { HOME } from "../../pkg/query/parameters";

const Header = (props) => {
  const title = props.title;
  const location = useLocation();
  const currentParam = GetParam(location.search);
  const isHomePage = currentParam === HOME;
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="site-header">
      {/* ナビゲーション */}
      <nav className={`site-nav ${isHomePage ? 'nav-overlay' : 'nav-solid'}`}>
        <div className="nav-inner">
          <div className="nav-brand">
            <a className="brand-link" href="./index.html">
              <img src="logo.png" alt="玉泉院" className="nav-logo" />
              <span className="brand-name">玉泉院</span>
            </a>
          </div>

          <button
            className={`nav-toggle ${isMenuOpen ? 'is-open' : ''}`}
            onClick={toggleMenu}
            aria-label="メニュー"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <div className={`nav-menu ${isMenuOpen ? 'is-open' : ''}`}>
            <a className="nav-link" href="./index.html" onClick={() => setIsMenuOpen(false)}>
              ホーム
            </a>
            <a className="nav-link" href="./index.html?view=about" onClick={() => setIsMenuOpen(false)}>
              当院について
            </a>
            <a className="nav-link" href="./index.html?view=gyouji" onClick={() => setIsMenuOpen(false)}>
              年中行事
            </a>
            <a
              className="nav-link"
              href="https://www.google.com/maps/place/%E7%8E%89%E6%B3%89%E9%99%A2/@34.3030102,135.7281878,17z/data=!3m1!4b1!4m5!3m4!1s0x6006daebd1088d3b:0x167607ff0690a7d7!8m2!3d34.3030058!4d135.7303818?hl=ja"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setIsMenuOpen(false)}
            >
              アクセス
            </a>
            <div className="nav-sns">
              <a href="https://www.facebook.com/gyokusenin/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://www.instagram.com/gyokusenin/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://lin.ee/v8jwj8W" aria-label="LINE">
                <i className="fab fa-line"></i>
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* トップページ: フルスクリーンヒーロー */}
      {isHomePage && (
        <div className="hero-full">
          <div
            className="hero-bg"
            style={{ backgroundImage: `url(${image})` }}
          ></div>
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <img src="logo.png" alt="玉泉院" className="hero-logo" />
            <h1 className="hero-title">{title}</h1>
            <p className="hero-subtitle">真言宗御室派</p>
          </div>
          <div className="hero-scroll-hint">
            <span></span>
          </div>
        </div>
      )}

      {/* 詳細ページ: コンパクトヒーロー */}
      {!isHomePage && (
        <div className="hero-compact">
          <div
            className="hero-bg"
            style={{ backgroundImage: `url(${image})` }}
          ></div>
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1 className="hero-title-small">{title}</h1>
          </div>
        </div>
      )}

      {/* トップページ: サブメニュー */}
      {isHomePage && (
        <section className="sub-menu">
          <div className="sub-menu-inner">
            <a href="./index.html?view=touinnkaiso" className="sub-menu-link">
              <span className="sub-menu-label">当院開創</span>
            </a>
            <a href="./index.html?view=nannbokutyojidai" className="sub-menu-link">
              <span className="sub-menu-label">南北朝時代</span>
            </a>
            <a href="./index.html?view=gomaku" className="sub-menu-link">
              <span className="sub-menu-label">祈祷</span>
            </a>
            <a href="./index.html?view=kuyou" className="sub-menu-link">
              <span className="sub-menu-label">供養</span>
            </a>
            <a href="./index.html?view=oterataiken" className="sub-menu-link">
              <span className="sub-menu-label">お寺体験</span>
            </a>
            <a href="./index.html?view=hiwatari" className="sub-menu-link">
              <span className="sub-menu-label">火渡り修行</span>
            </a>
          </div>
        </section>
      )}
    </header>
  );
};

export default Header;
